import {
  CLEAR_EDITING_CUSTOMER,
  CLEAR_ERROR_MESSAGE,
  CLEAR_SUCCESS_MESSAGE,
  CREATE_CUSTOMER_ERROR,
  CREATE_CUSTOMER_INIT,
  CREATE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_ERROR,
  DELETE_CUSTOMER_INIT,
  DELETE_CUSTOMER_SUCCESS,
  FETCH_AGENTS_ERROR,
  FETCH_AGENTS_INIT,
  FETCH_AGENTS_SUCCESS,
  FETCH_CUSTOMERS_ERROR,
  FETCH_CUSTOMERS_INIT,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_TENANTS_ERROR,
  FETCH_TENANTS_INIT,
  FETCH_TENANTS_SUCCESS,
  HIDE_DELETE_MODAL,
  RESET_FORM_DATA,
  SET_EDITING_CUSTOMER,
  SET_ERROR_MESSAGE,
  SET_FORM_DATA,
  SET_LOADING_STATE,
  SET_SELECTED_CUSTOMER,
  SET_SELECTED_TENANT,
  SET_SUCCESS_MESSAGE,
  SHOW_DELETE_MODAL,
  UPDATE_CUSTOMER_ERROR,
  UPDATE_CUSTOMER_INIT,
  UPDATE_CUSTOMER_SUCCESS,
} from "./types";

const initialFormData = {
  domotz_customer_id: "",
  customer_name: "",
  status: "active",
  contact_email: "",
  contact_phone: "",
  billing_address: {
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  },
  service_address: {
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  },
  max_agents: "",
  max_devices: "",
  contract_start_date: null,
  contract_end_date: null,
};

const initialState = {
  // Tenant data
  tenants: [],
  selectedTenant: null,
  tenantsLoading: false,
  tenantsError: null,

  // Customer data
  customers: [],
  customersLoading: false,
  customersError: null,
  totalCustomers: 0,
  selectedCustomer: null,

  // Agent data
  agents: [],
  agentsLoading: false,
  agentsError: null,
  totalAgents: 0,
  agentsPagination: null,

  // CRUD operations loading states
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,

  // Form state
  formData: { ...initialFormData },
  editingCustomer: null,

  // UI state
  isLoading: false,
  errorMessage: null,
  successMessage: null,

  // Delete modal state
  showDeleteModal: false,
  customerToDelete: null,
};

export default function iSightCustomersReducer(state = initialState, action) {
  switch (action.type) {
    // Tenant actions
    case FETCH_TENANTS_INIT:
      return {
        ...state,
        tenantsLoading: true,
        tenantsError: null,
      };

    case FETCH_TENANTS_SUCCESS:
      return {
        ...state,
        tenants: action.payload,
        tenantsLoading: false,
        tenantsError: null,
      };

    case FETCH_TENANTS_ERROR:
      return {
        ...state,
        tenantsLoading: false,
        tenantsError: action.payload,
        tenants: [],
      };

    // Customer fetch actions
    case FETCH_CUSTOMERS_INIT:
      return {
        ...state,
        customersLoading: true,
        customersError: null,
      };

    case FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.payload.customers,
        totalCustomers: action.payload.totalCount,
        customersLoading: false,
        customersError: null,
      };

    case FETCH_CUSTOMERS_ERROR:
      return {
        ...state,
        customersLoading: false,
        customersError: action.payload,
        customers: [],
        totalCustomers: 0,
      };

    // Customer create actions
    case CREATE_CUSTOMER_INIT:
      return {
        ...state,
        createLoading: true,
        errorMessage: null,
      };

    case CREATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        createLoading: false,
        formData: { ...initialFormData },
        editingCustomer: null,
        successMessage: "Customer created successfully",
      };

    case CREATE_CUSTOMER_ERROR:
      return {
        ...state,
        createLoading: false,
        errorMessage: action.payload,
      };

    // Customer update actions
    case UPDATE_CUSTOMER_INIT:
      return {
        ...state,
        updateLoading: true,
        errorMessage: null,
      };

    case UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        formData: { ...initialFormData },
        editingCustomer: null,
        successMessage: "Customer updated successfully",
      };

    case UPDATE_CUSTOMER_ERROR:
      return {
        ...state,
        updateLoading: false,
        errorMessage: action.payload,
      };

    // Customer delete actions
    case DELETE_CUSTOMER_INIT:
      return {
        ...state,
        deleteLoading: true,
        errorMessage: null,
      };

    case DELETE_CUSTOMER_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        customers: state.customers.filter(
          (customer) => customer.id !== action.payload,
        ),
        totalCustomers: state.totalCustomers - 1,
        showDeleteModal: false,
        customerToDelete: null,
        successMessage: "Customer deleted successfully",
      };

    case DELETE_CUSTOMER_ERROR:
      return {
        ...state,
        deleteLoading: false,
        errorMessage: action.payload,
        showDeleteModal: false,
        customerToDelete: null,
      };

    // Form state actions
    case SET_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          ...action.payload,
        },
      };

    case RESET_FORM_DATA:
      return {
        ...state,
        formData: { ...initialFormData },
        editingCustomer: null,
      };

    case SET_EDITING_CUSTOMER:
      return {
        ...state,
        editingCustomer: action.payload,
        formData: {
          domotz_customer_id: action.payload?.domotz_customer_id || "",
          customer_name: action.payload?.customer_name || "",
          status: action.payload?.status || "active",
          contact_email: action.payload?.contact_email || "",
          contact_phone: action.payload?.contact_phone || "",
          billing_address: action.payload?.billing_address || {
            street: "",
            city: "",
            state: "",
            zip: "",
            country: "",
          },
          service_address: action.payload?.service_address || {
            street: "",
            city: "",
            state: "",
            zip: "",
            country: "",
          },
          max_agents: action.payload?.max_agents || "",
          max_devices: action.payload?.max_devices || "",
          contract_start_date: action.payload?.contract_start_date || null,
          contract_end_date: action.payload?.contract_end_date || null,
        },
      };

    case CLEAR_EDITING_CUSTOMER:
      return {
        ...state,
        editingCustomer: null,
        formData: { ...initialFormData },
      };

    // UI state actions
    case SET_SELECTED_TENANT:
      return {
        ...state,
        selectedTenant: action.payload,
        customers: [],
        totalCustomers: 0,
        formData: { ...initialFormData },
        editingCustomer: null,
      };

    case SET_LOADING_STATE:
      return {
        ...state,
        isLoading: action.payload,
      };

    case SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      };

    case CLEAR_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: null,
      };

    case SET_SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: action.payload,
      };

    case CLEAR_SUCCESS_MESSAGE:
      return {
        ...state,
        successMessage: null,
      };

    // Modal actions
    case SHOW_DELETE_MODAL:
      return {
        ...state,
        showDeleteModal: true,
        customerToDelete: action.payload,
      };

    case HIDE_DELETE_MODAL:
      return {
        ...state,
        showDeleteModal: false,
        customerToDelete: null,
      };

    // Customer selection for agents
    case SET_SELECTED_CUSTOMER:
      return {
        ...state,
        selectedCustomer: action.payload,
        agents: [], // Clear agents when customer changes
        totalAgents: 0,
      };

    // Agent fetch actions
    case FETCH_AGENTS_INIT:
      return {
        ...state,
        agentsLoading: true,
        agentsError: null,
      };

    case FETCH_AGENTS_SUCCESS:
      return {
        ...state,
        agents: action.payload.agents,
        totalAgents: action.payload.totalCount,
        agentsPagination: action.payload.pagination,
        agentsLoading: false,
        agentsError: null,
      };

    case FETCH_AGENTS_ERROR:
      return {
        ...state,
        agentsLoading: false,
        agentsError: action.payload,
        agents: [],
        totalAgents: 0,
      };

    default:
      return state;
  }
}
